import Keycloak from 'keycloak-js';
import { getBaseUrl } from '../utils';

export const login = (kc: Keycloak) => {
  const url = new URL(window.location.href);
  kc.login({
    redirectUri: `${getBaseUrl(url)}/tenants`,
  });
};

export const logout = (kc: Keycloak, isUserAction: boolean = false) => {
  const url = new URL(window.location.href);
  const baseUrl = getBaseUrl(url);
  kc.logout({
    redirectUri: isUserAction
      ? `${baseUrl}/unauthorized`
      : `${baseUrl}/unauthorized?from=${kc.redirectUri}`,
  });
};
